import { clearAllApplicantLoanDetails } from "../../services/redux/slices/applicationLoanDetailsSlice";
import {
  setChatStatusConfig,
  setCurrentSessionId,
  setSalesUserId,
} from "../../services/redux/slices/chatSlice";
import {
  clearAadhaarApplicationNoCoApplicant,
  clearAadhaarVerifiedDetails,
  clearAadhaarVerifiedDetailsCoApplicant,
  clearActiveIndex,
  clearCoApplicantVerification,
  clearFormData,
  clearIsDocumentVerifiedCoApplicant,
  clearSavedBasicCoApplicants,
  clearSetLoanDetailCoApplicantCollapseValue,
  removeDigiLockerLoaderId,
  setAadhaarMandatory,
  setAadhaarSeedingStatus,
  setActiveHorizontalIndex,
  setActiveVerticalIndex,
  setApplicantId,
  setApplicationId,
  setApplicationSource,
  setAssignedSMIdValue,
  setCheckIsLeadApiInvoked,
  setCollateralId,
  setCompletedHorizontalIndex,
  setDisplayHorizontalSteps,
  setHasPan,
  setIsDocumentVerified,
  setIsEligibilityCheckSubmitted,
  setIsEligible,
  setIsEmailVerified,
  setIsMobileVerified,
  setIsPanVerified,
  setLastPanNumber,
  setLastVerifiedEmail,
  setLastVerifiedPhoneNumber,
  setLeadSequenceId,
  setPanNumber,
  setreferenceOneId,
  setreferenceTwoId,
  setShowAadhaar,
  setTrackingId,
} from "../../services/redux/slices/stepperDynamicFormSlice";
import { setOpenFirstTimeOnlyPopup } from "../../services/redux/slices/tabsSlice";

export const normalizeStepName = (value: any): string =>
  String(value || "")
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");

export const isStepCompleted = (obj: Record<string, any>): boolean => {
  console.log(obj, "objobjobj");
  // If input is missing, not an object, or empty, return false
  if (!obj || typeof obj !== "object" || Object.keys(obj).length === 0) {
    console.log(obj, "objobjobj");
    return false;
  }

  // .every() returns true only if all keys pass the condition
  return Object.values(obj).every((value) => {
    // 1. Check for null or undefined
    if (value === null || value === undefined) {
      console.log(obj, "objobjobj");
      return false;
    }

    // 2. Check for empty strings or strings with only blank spaces
    if (typeof value === "string") {
      console.log(obj, "objobjobj");
      return value.trim() !== "";
    }
    // Numbers (like 0) and booleans (like false) are valid filled inputs
    return true;
  });
};

export const hasStepFieldData = (step: any): boolean => {
  if (!Array.isArray(step?.fields)) return false;

  return step.fields.some((field: any) =>
    Object.values(field || {}).some((value: any) => {
      if (value === null || value === undefined) return false;
      if (typeof value === "string") return value.trim() !== "";
      if (typeof value === "boolean") return value;
      if (typeof value === "number") return !Number.isNaN(value);
      if (typeof value === "object") {
        if ("value" in value || "label" in value) {
          return String(value?.value ?? value?.label ?? "").trim() !== "";
        }
        return Object.keys(value).length > 0;
      }
      return true;
    }),
  );
};

export const resolveAdditionalDetailsResumeVerticalIndex = (
  step: any,
  horizontalData?: any,
): number => {
  const verticalSteps = Array.isArray(step?.verticalSteps)
    ? step.verticalSteps
    : [];
  const horizontalStepsData = horizontalData || [];

  const loanDetailsFields =
    horizontalStepsData?.[1].verticalSteps?.find((vStep: any) =>
      normalizeStepName(vStep?.verticalStepName).includes(
        normalizeStepName("Co-Applicant Details"),
      ),
    )?.fields || [];
  const collateralEntry =
    loanDetailsFields?.find((field: any) =>
      Object.keys(field).some((key) =>
        normalizeStepName(key).includes(normalizeStepName("Collateral")),
      ),
    ) || null;

  if (!verticalSteps.length) return 0;

  const fundsStep = verticalSteps.find((verticalStep: any) =>
    normalizeStepName(verticalStep?.verticalStepName).includes("fund"),
  );
  const referenceStep = verticalSteps.find((verticalStep: any) =>
    normalizeStepName(verticalStep?.verticalStepName).includes("reference"),
  );
  const collateralStep = verticalSteps.find((verticalStep: any) =>
    normalizeStepName(verticalStep?.verticalStepName).includes("collateral"),
  );
  console.log(fundsStep, isStepCompleted(fundsStep), "fundsStepfundsStep");
  const hasAnyAdditionalData =
    hasStepFieldData(fundsStep) ||
    hasStepFieldData(referenceStep) ||
    hasStepFieldData(collateralStep) ||
    isStepCompleted(fundsStep) ||
    isStepCompleted(referenceStep) ||
    isStepCompleted(collateralStep);

  // Helper: check if both sub-sections (1 and 2) of a step have field data
  const hasBothSubSections = (vStep: any, prefix: string): boolean => {
    if (!Array.isArray(vStep?.fields)) return false;
    const allKeys = vStep.fields.flatMap((f: any) => Object.keys(f || {}));
    const hasSection1 = allKeys.some((k: string) =>
      k.toLowerCase().startsWith(`${prefix}1`) &&
      allKeys.find((k2: string) => k2 === k)
        ? String(
            (vStep.fields.find((f: any) => k in f) || {})[k] || "",
          ).trim() !== ""
        : false,
    );
    const hasSection2 = allKeys.some((k: string) =>
      k.toLowerCase().startsWith(`${prefix}2`) &&
      allKeys.find((k2: string) => k2 === k)
        ? String(
            (vStep.fields.find((f: any) => k in f) || {})[k] || "",
          ).trim() !== ""
        : false,
    );
    return hasSection1 && hasSection2;
  };

  const collateralValue = (collateralEntry?.collateral ?? "")
    .toString()
    .trim()
    .toLowerCase();

  const referenceFullyFilled =
    isStepCompleted(referenceStep) ||
    hasBothSubSections(referenceStep, "basicreference");
  const collateralFullyFilled =
    // If collateral is "No" or empty, consider it complete
    collateralValue === "no" || collateralValue === ""
      ? true
      : // If collateral is "Yes", validate collateral fields
        (collateralStep?.fields?.some((obj: any) =>
          Object.keys(obj).some((key) =>
            key.toLowerCase().includes("collateral"),
          ),
        ) ?? false);

  if (!hasAnyAdditionalData) return 0;
  // If funds step is not completed, land on Fund & Expense page (index 2)
  if (!isStepCompleted(fundsStep)) return 2;
  // If both reference and collateral are fully filled/completed → move to next stage: document & consent (index 4)
  console.log(
    referenceFullyFilled,
    collateralFullyFilled,
    collateralStep,
    "referenceFullyFilled",
  );
  if (referenceFullyFilled && collateralFullyFilled) return 4;
  // Otherwise land on Reference & Collateral page (index 3)
  return 3;
};

export const handleClearData = (dispatch: any) => {
  // dispatch(setTrackingId(""));
  dispatch(setCollateralId(null));
  dispatch(setreferenceOneId(null));
  dispatch(setreferenceTwoId(null));
  dispatch(setApplicationId(""));
  dispatch(setLeadSequenceId(""));
  dispatch(setCompletedHorizontalIndex(null));
  dispatch(setActiveHorizontalIndex(0));
  dispatch(setActiveVerticalIndex(0));
  dispatch(clearActiveIndex());
  dispatch(clearFormData());
  dispatch(setLastVerifiedPhoneNumber(""));
  dispatch(setLastVerifiedEmail(""));
  dispatch(setIsDocumentVerified(false));
  dispatch(setIsMobileVerified(false));
  dispatch(setIsEmailVerified(false));
  dispatch(setIsPanVerified(false));
  dispatch(setPanNumber(""));
  dispatch(setAadhaarMandatory(false));
  dispatch(setIsEligibilityCheckSubmitted(false));
  dispatch(setShowAadhaar(false));
  dispatch(setHasPan(""));
  dispatch(removeDigiLockerLoaderId());
  localStorage.removeItem("applicationNo");
  dispatch(clearCoApplicantVerification());
  dispatch(clearIsDocumentVerifiedCoApplicant());
  dispatch(clearAadhaarApplicationNoCoApplicant());
  dispatch(clearAadhaarVerifiedDetailsCoApplicant());
  dispatch(clearAadhaarVerifiedDetails());
  dispatch(setLastPanNumber(""));
  dispatch(clearSetLoanDetailCoApplicantCollapseValue());
  dispatch(setAssignedSMIdValue(""));
  dispatch(setSalesUserId(""));
  dispatch(setCurrentSessionId(""));
  dispatch(setOpenFirstTimeOnlyPopup(null));
  dispatch(clearAllApplicantLoanDetails());
  dispatch(setAadhaarSeedingStatus(null));
  dispatch(setIsEligible(false));
  dispatch(setApplicationSource(""));
  dispatch(setDisplayHorizontalSteps([]));
  dispatch(clearSavedBasicCoApplicants());
  dispatch(setChatStatusConfig({}));
};

export const extractCoApplicantKeysFromData = (fieldObjects: any[]) => {
  const coApplicantSet = new Set<string>();
  fieldObjects?.forEach((obj: any) => {
    Object.keys(obj || {}).forEach((key) => {
      const match = key.match(/CoApplicant(\d+)/);
      if (match?.[1]) {
        coApplicantSet.add(`CoApplicant${match[1]}`);
      }
    });
  });
  return Array.from(coApplicantSet);
};

export const handleInvokeLeadApiData = (apps: any, dispatch: any) => {
  dispatch(setTrackingId(apps?.submissionId));
  dispatch(setApplicationId(apps?.applicationId));
  dispatch(setApplicantId(apps?.applicantId));
  dispatch(setLeadSequenceId(apps?.leadId));
  dispatch(setAssignedSMIdValue(apps?.assignedSMId));

  dispatch(
    setCheckIsLeadApiInvoked({
      key: "ASSIGN_SM",
      value: apps?.assignedSMId ? true : false,
    }),
  );
  dispatch(
    setCheckIsLeadApiInvoked({
      key: "CREATE_LEAD",
      value: apps?.assignedSMId && apps?.leadId ? true : false,
    }),
  );
  dispatch(
    setCheckIsLeadApiInvoked({
      key: "LEAD_TO_APPLICATION",
      value:
        apps?.applicantId && apps?.applicationId && apps?.applicationDisplayCode
          ? true
          : false,
    }),
  );
};

export const findLastFilledHorizontalStepIndex = (steps: any[]): number => {
  let lastFilledIndex = -1;
  (steps || []).forEach((step: any, index: number) => {
    if (Array.isArray(step?.verticalSteps) && step.verticalSteps.length > 0) {
      lastFilledIndex = index;
    }
  });
  return lastFilledIndex;
};

export const parseBooleanFlag = (value: any): boolean => {
  if (typeof value === "boolean") return value;
  if (typeof value === "string") return value.toLowerCase() === "true";
  return false;
};

export const getOrderedData = (data: any[]) => {
  const order = [
    "Product",
    "Applicant Type",
    "First Name",
    "Last Name",
    "Phone Number",
    "Email",
    "Pincode"
  ];

  // Get the ordered items first
  const orderedItems = order
    .map(label => data?.find((item: any) => item?.label?.includes(label)))
    .filter(Boolean);

  // Get remaining items that were not matched
  const remainingItems = data?.filter(
    (item: any) => !order.some(label => item?.label?.includes(label))
  ) || [];

  // Return ordered items + remaining items at the end
  return [...orderedItems, ...remainingItems];
}